import React from 'react';
import "./index.scss";
import { Menu, Dropdown } from 'antd';
import { useHistory } from 'react-router-dom';
import {
    UserOutlined,
    LogoutOutlined,
} from '@ant-design/icons';

import { cookie } from "../../approach/base";

const UserSetting = () => {
    const history = useHistory();
    const onMenuClick = ({ key }) => {
        switch (key) {
            case 'logout':
                cookie.delete("loginStatus");
                history.push('/login');
                break;
            default:
                console.log('未知key');
                break;
        }
    };
    const menu = () => {
        return (
            <Menu className="menu" selectedKeys={[]} onClick={onMenuClick}>
                <Menu.Item key="logout">
                    <LogoutOutlined />
                    退出登录
                    </Menu.Item>
            </Menu>
        );
    };
    return (
        <div className="UserSetting">
            <Dropdown
                overlay={menu}
                trigger={['hover', 'click']}
                placement="bottom"
            >
                <div
                    className="item-hover"
                    onClick={e => e.preventDefault()}
                >
                    <UserOutlined /> {cookie.get("loginStatus")?cookie.get("userNo")+cookie.get("userName"):""}
                </div>
            </Dropdown>
        </div>
    );
};

export default UserSetting;
